// extracted by mini-css-extract-plugin
export default {"idle":"Idle-module__idle--EONeX","copilotRun":"Idle-module__copilotRun--jiyBF"};